import { AutoComplete as BaseAutoComplete } from "antd"

export function AutoComplete(props: React.ComponentProps<typeof BaseAutoComplete>) {
    return <BaseAutoComplete {...props} />
}
